import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Award, FileDown, ArrowRight, Home } from 'lucide-react';
import confetti from 'canvas-confetti';

export default function Celebration({
  level,
  nextLevel,
  answers,
  globalRatio,
  onContinue,
  onHome,
}) {
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    const colors = ['#8A9A82', '#C9A86A', '#C08457', '#E8DFD3', '#3E4A40'];
    const fire = (particleRatio, opts) =>
      confetti({
        origin: { y: 0.6 },
        colors,
        particleCount: Math.floor(220 * particleRatio),
        ...opts,
      });
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });
  }, []);

  const handleExport = async () => {
    setExporting(true);
    try {
      const { exportLevelPdf } = await import('./RoadmapPdf');
      await exportLevelPdf(level, answers, globalRatio);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="rm-celebrate">
      <motion.div
        className="rm-celebrate-card"
        initial={{ opacity: 0, scale: 0.85, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
      >
        <motion.div
          className="rm-badge-big"
          initial={{ rotate: -20, scale: 0 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
        >
          <Award size={46} strokeWidth={1.4} />
        </motion.div>

        <span className="rm-celebrate-eyebrow">Niveau {level.id} terminé</span>
        <h2 className="rm-celebrate-title">{level.title}, c’est fait !</h2>
        <p className="rm-celebrate-badge-label">
          Badge débloqué : <strong>{level.badge.label}</strong>
        </p>
        <div className="rm-xp-pop">+{level.items.length * 10 + 50} XP</div>

        <p className="rm-celebrate-text">
          {nextLevel
            ? `Le niveau « ${nextLevel.title} » est maintenant déverrouillé.`
            : 'Tu as terminé toute ta roadmap. Bravo, c’est immense.'}
        </p>

        <div className="rm-celebrate-actions">
          <button
            className="rm-btn rm-btn-secondary"
            onClick={handleExport}
            disabled={exporting}
          >
            <FileDown size={18} />
            {exporting ? 'Génération…' : 'Exporter le PDF'}
          </button>
          {nextLevel ? (
            <button className="rm-btn rm-btn-primary" onClick={onContinue}>
              Niveau suivant
              <ArrowRight size={18} />
            </button>
          ) : (
            <button className="rm-btn rm-btn-primary" onClick={onHome}>
              <Home size={18} />
              Retour à l’accueil
            </button>
          )}
        </div>

        {nextLevel && (
          <button className="rm-link" onClick={onHome}>
            Revenir à la carte
          </button>
        )}
      </motion.div>
    </div>
  );
}
